import {getTransformAlong} from "rete-connection-path-plugin";
import Vue from "vue";

class PatchNode {
    static editor;

    constructor(editor, ref) {
        this.editor = editor
        this.svg = ref.el.firstChild
        this.d = ''
        this.nodePosition = [0,0]
        this.connection = ref.connection
    }

    createMarker() {
        this.marker = document.createElementNS('http://www.w3.org/2000/svg', 'path')
        this.marker.classList.add('marker')
        this.marker.setAttribute('fill', '#9d9d9d')
        this.marker.setAttribute('d', 'M -3 -5 L -3 5 L 8 0 z')
        this.marker.setAttribute('transform', getTransformAlong(this.svg.firstChild, -10))
    }

    createActionPath() {
        this.path = document.createElementNS('http://www.w3.org/2000/svg', 'path')
        this.path.classList.add('main-path-action-area')
        this.path.addEventListener('click', () => {
            this.editor.trigger('connetionfocus',  this)
        })
        this.path.addEventListener('contextmenu', (e) => {

            this.editor.trigger('contextmenu', {
                e, node: {
                    name: 'path',
                    connection: this.connection,
                }
            })
        })
    }

    createPathNode(component) {
        this.nodePosition = this.path ? this.getMiddlePathPosition(this.svg.firstChild) : [0, 0]
        Vue.observable(this.nodePosition)
        Vue.observable(this.connection)
        
        let divEl = document.createElement('div')
    
        const app = new Vue({
            render: (h) => h(component, {
                props: {
                    position: this.nodePosition,
                    connection: this.connection,
                    editor: this.editor
                }
            })
        })
        this.svg.parentElement.appendChild(divEl)

        if(this.connection && this.connection.data && this.connection.data.focus && this.connection.data.focus ===true ){
            this.svg.firstChild.classList.add('focus')
        }        

        app.$mount(divEl)
        this.vueContext = app.$children[0]
    }

    getMiddlePathPosition(path) {
        if (!path) return [0,0]

        const length = path.getTotalLength();
        const {x, y} = path.getPointAtLength(length/2);
        return [x, y]
    }

    render(ref) {
        if (this.path)
            this.svg.appendChild(this.path)
        if (this.marker)
            this.svg.appendChild(this.marker)

        this.update(ref)
    }

    focus() {
        this.svg.firstChild.classList.add('focus')
        this.editor.on('clearfocus', () => {
            if (this.svg.firstChild.classList.contains('focus'))
                this.svg.firstChild.classList.remove('focus')
        })
    }

    update(ref) {
        this.points = ref.points
        this.connection = ref.connection
        this.editor.trigger('connectionpath', this)

        if (this.path)
            this.path.setAttribute('d', this.d)

        if (this.marker)
            this.marker.setAttribute('transform', getTransformAlong(this.svg.firstChild, -10))

        if (this.vueContext){
            const position = this.path ? this.getMiddlePathPosition(this.svg.firstChild) : [0, 0]
            if (this.nodePosition[0] !== position[0] || this.nodePosition[1] !== position[1]){
                this.nodePosition[0] = position[0]
                this.nodePosition[1] = position[1]
                this.vueContext.$forceUpdate()
            }
        }
    }

}

function install(editor, {vuePathNodeComponent}) {
    editor.bind('connetionfocus')
    editor.bind('clearfocus')

    editor.on('renderconnection', (ref) => {
        let pathNode = null
        pathNode = new PatchNode(editor, ref)
        pathNode.createActionPath()
        pathNode.createMarker()
        pathNode.createPathNode(vuePathNodeComponent)
        pathNode.render(ref)
        ref.connection.data = {...ref.connection.data, actionPath: pathNode }
    })

    editor.on('updateconnection', (ref) => {
        if (Object.keys(ref.connection.data).length === 0) return
        ref.connection.data.actionPath.update(ref)
    })

}

export default {
    name: 'path-vue-node',
    install
}
